import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
export function formatUtcToData(data: string, formatString: string): string {
  return dayjs.utc(data).utcOffset(8).format(formatString);
}

export function getSex(type: string) {
  if(type == '1') {
    return '男'
  }else {
    return '女'
  }
}

export function getTagType(status: number) {
  switch(status) {
    case 0:
      return 'success';
    case 1:
      return 'warning';
    case 2:
      return 'error'
    case 3:
      return 'info'
  }
}

/**
 * 金融格式化
 * @param amount 金额stirng | number
 * @param precision 小数位数
 * @param unit 是否单单位
 * @returns 
 */
export function amountFormat(amount: string | number, precision: number, unit: boolean){
  if(amount =='')  {
    amount ='0'
    precision = precision > 0 && precision <= 20 ? precision : 2;
    amount =parseFloat((amount).replace(/[^\d.-]/g,"")).toFixed(precision)+""; 
  }
  let t ="";
  if(typeof amount === 'number') {
    amount = amount.toString();
  }
  const l = amount.split(".")[0].split("").reverse();
  let r = amount.split(".")[1] ? amount.split(".")[1] : '00';
  if(r.length == 1) {
    r += '0';
  }
  
  for(let i =0; i < l.length; i++){
      t += l[i]+((i +1)%3==0&&(i +1)!= l.length ?",":"");
  }
  if(unit){
    return t.split("").reverse().join("")+"."+ r +'元';
  }else{
    return t.split("").reverse().join("")+"."+ r;
  }
  }

